import { createContext, useEffect, useState, useMemo, useRef } from 'react';
import { getStorageValue } from '@portal-internet/core';
import __isEmpty from 'lodash/isEmpty';
export const ModalContext = createContext();

const FULL_SCREEN = 'full-screen';

const defaultOptions = {
    mode: FULL_SCREEN
};

const ModalProvider = (props) => {
    const { children } = props;

    const [openModal, setOpenModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [optionsModal, setOptionsModal] = useState(defaultOptions);
    const [mutePlayer, setMutePlayer] = useState(false);
    const optionsModalRef = useRef({});
    const focusPage = useRef({
        currentFocus: null,
        lastFocusOnPage: null
    });

    const setModal = (content, options = defaultOptions) => {
        focusPage.current.lastFocusOnPage = focusPage.current.currentFocus;
        options = { ...defaultOptions, ...options };
        optionsModalRef.current = options;

        setOpenModal(true);
        setOptionsModal(options);
        setModalContent(content);

        if (typeof document !== 'undefined' && optionsModalRef?.current?.mode === FULL_SCREEN) {
            document.body.classList.add('is-modal-fullscreen');
        }

        if (typeof document !== 'undefined' && optionsModalRef?.current.isModalSegueix){
            document.body.classList.add('is-modal-segueix-loaded');
        }
    };

    const removeModal = () => {
        setTimeout(() => {
            focusPage.current.lastFocusOnPage?.focus();
            focusPage.current.lastFocusOnPage = null;
        }, 250);

        if (typeof document !== 'undefined' && optionsModalRef?.current?.mode === FULL_SCREEN) {
            document.body.classList.remove('is-modal-fullscreen');
        }

        if (typeof document !== 'undefined' && optionsModalRef?.current.isModalSegueix){
            document.body.classList.remove('is-modal-segueix-loaded');
        }

        setOpenModal(false);
        setModalContent(null);
    };

    const setPlayerMutedByCCMAStorage = async () => {
        const muted = (await getStorageValue('bmplayer.3cat.muted')) === 'true';
        setMutePlayer(muted);
    };

    const handleFocusin = (e) => {
        focusPage.current.currentFocus = e.target;
    };

    useEffect(() => {
        setPlayerMutedByCCMAStorage();
        document.addEventListener('focusin', handleFocusin);

        return () => {
            document.removeEventListener('focusin', handleFocusin);
        };
    }, []);

    useEffect(() => {
        if (!__isEmpty(optionsModalRef?.current)) {
            if (optionsModalRef?.current?.mode === FULL_SCREEN) {
                document.body.style.overflow = openModal ? 'hidden' : 'auto';
                return () => {
                    document.body.style.overflow = 'auto';
                };
            }
        }
    }, [openModal]);

    const contextValue = useMemo(
        () => ({
            openModal,
            modalContent,
            optionsModal,
            mutePlayer,
            setModal,
            removeModal,
            setMutePlayer
        }),
        [modalContent, optionsModal, mutePlayer]
    );

    return <ModalContext.Provider value={contextValue}>{children}</ModalContext.Provider>;
};

export default ModalProvider;
